module.exports = __webpack_public_path__ + "static/media/licence1-ueasy.7f63641c.png";